import React, { lazy, Suspense } from "react";
import {
  Box,
  Button,
  Flex,
  Gap,
  Typography,
} from "../../../ppui";
import { Snackbar } from "../../../ppui/snackbar";
import ErrorBoundary from "../../../utils/error-boundary";
import AllowanceList from "./allowance-list";
import useAllowanceService from "./use-allowance-service";


const AllowanceForm = lazy(() => import("./allowance-form"))

function OrganizationAllowance() {

  const {

    allowancedialogOpen, setAllowancedialogOpen,
    loadingUi,
    handleChangeFunction,
    allowance,
    onSubmitHandler,
    setAllowance,
    allowanceListResponse,
    ALLOWANCE_INITIAL_STATE,
    setAllowanceListResponse,

    getInputFieldProps,
    addAnotherAllowance, setaddAnotherAllowance,

    setErrors,


    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
  } = useAllowanceService();



  return (
    <>
      <Box style={{ display: "none" }}>
        <Typography variant="h5">Allowance Information</Typography>

      </Box>
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Allowance Information
        </Typography>
        <Button onClick={() => {
          setErrors({})
          setAllowance(ALLOWANCE_INITIAL_STATE);
          setAllowancedialogOpen(true)
        }} variant="outlined" size="sm">
          Add New
        </Button>
      </Flex>
      <ErrorBoundary fallback={<div>Something went wrong</div>}>
        <Suspense fallback={<p>loading.....</p>}>
          <AllowanceList
            setAllowanceListResponse={setAllowanceListResponse}
            setErrors={setErrors}
            setAllowancedialogOpen={setAllowancedialogOpen}
            setAllowance={setAllowance}
            allowanceListResponse={allowanceListResponse}

            isFetching={loadingUi} />
        </Suspense>
      </ErrorBoundary>
      <Gap height={100} />
      {/* <Flex justifyContent="flex-end" gap={"10"}>
        <Button onClick={() => { }} variant="outlined">
          Cancel
        </Button>
       
        <Button color="primary" disabled={!allowanceListResponse?.length} loading={createUpdateLoading} onClick={() => { onSubmitApi() }} variant="contained">
        Save
        </Button>
      </Flex> */}
      <Gap height={100} />
      <ErrorBoundary fallback={<div>Something went wrong</div>}>
        <Suspense fallback={<p>Loading dialog....</p>}>
          <AllowanceForm
            handleChangeFunction={handleChangeFunction}
            allowance={allowance}
            onSubmitHandler={onSubmitHandler}
            getInputFieldProps={getInputFieldProps}
            allowancedialogOpen={allowancedialogOpen}
            setAllowancedialogOpen={setAllowancedialogOpen}
            addAnotherAllowance={addAnotherAllowance}
            setaddAnotherAllowance={setaddAnotherAllowance}

          />
        </Suspense>
      </ErrorBoundary>

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default OrganizationAllowance;
